import React from 'react';
import MachineTypes from '../features/machineTypes';

export default function MachineTypesPage () {
  return (
    <MachineTypes />
  );
}